export default __webpack_public_path__ + "static/media/ico-ads-pro.e08947d2.webp";